import React from 'react';
import { connect } from 'react-redux';
import { ContentWebsitButton } from '../components/pages/waiting-area/webSite-Button/content';

function WaitingAreaWebsiteButtonPage(props) {
  return (
    <>
      <ContentWebsitButton
        showWaitingAreaModel={props.showWaitingAreaModel}
        waitingArea={props.waitingArea}
        waitingAreaWebsiteButton={props.waitingAreaWebsiteButton}
      />
    </>
  );
}

function mapStateToProps(state) {
  let waitingArea = state.waitingAreaReducer.cleanWaitingArea;
  if (!!state.waitingAreaReducer.selectedWaitingAreaId)
    waitingArea = state.waitingAreaReducer.waitingAreas.find(
      (wa) => wa.id === state.waitingAreaReducer.selectedWaitingAreaId
    );

  return {
    waitingArea: waitingArea,
    waitingAreaWebsiteButton:
      state.waitingAreaReducer.waitingArea && state.waitingAreaReducer.waitingAreaWebsiteButton
        ? state.waitingAreaReducer.waitingAreaWebsiteButton
        : undefined,
    showWaitingAreaModel: state.modalReducer.showWebsiteButtonWaitingAreaModal ? true : false,
  };
}
export default connect(mapStateToProps, null)(WaitingAreaWebsiteButtonPage);
